







































































import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import HasValidation from "@/mixins/HasValidation";

// Types
import { ISelectorOption } from "@/models/forms";

@Component
export default class URadioSelectorWithDefault extends Mixins(HasValidation) {
  // Props

  @Prop({ required: true })
  public value!: any;

  @Prop({ required: true })
  public defaultValue!: any;

  @Prop({ required: true })
  public defaultOptionValue!: any;

  @Prop({ required: true })
  public options!: ISelectorOption[];

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: null })
  public label!: string;

  @Prop({ default: null })
  public vname!: string;

  @Prop({ required: true })
  public vid!: string;

  @Prop({ default: "" })
  public rules!: string;

  @Prop({ default: "value" })
  public nativeValuePath!: string;

  // Methods

  public onClick(option) {
    if (this.isDisabled) return;
    this.validate();
    const newItem = this.prepareValue(this.getValue(option));
    this.$emit("input", newItem);
  }

  public getValue(item) {
    return this.nativeValuePath
      ? this.$_.get(item, this.nativeValuePath)
      : item;
  }

  public isSelected(item) {
    return this.value === this.getValue(item);
  }

  public isUsingDefault(option) {
    return (
      this.defaultValue === option.value &&
      this.value === this.defaultOptionValue
    );
  }

  public prepareValue(value) {
    return this.value === value ? this.defaultOptionValue : value;
  }
}
